<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { require_classification_on_resolve } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!require_classification_on_resolve;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.REQUIRE_CLASSIFICATION.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.REQUIRE_CLASSIFICATION.API.ERROR'));
  }
};

const toggleRequireClassification = async () => {
  return updateAccountSettings({
    require_classification_on_resolve: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.REQUIRE_CLASSIFICATION.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.REQUIRE_CLASSIFICATION.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleRequireClassification" />
      </div>
    </template>
  </SectionLayout>
</template>
